export const SendTypes = [
  { label: '储值卡', value: 1 },
  { label: '电子现金', value: 0 }
]
export const CardTypes = [
  { label: '不定额卡', value: 1 },
  { label: '动态充值卡', value: 2 }
]
export const ExamStatus = [
  { label: '已审核', value: 2 },
  { label: '待审核', value: 1 }
]
export const OrderStatus = [
  { label: '已完成', value: 3 },
  { label: '待发卡', value: 2 }
]

export function getLabel (arr, val) {
  return arr.find(e => e.value === val)?.label || ''
}
